const primaryMain = '#003DA5';
const primaryMainOpacity = 'rgba(0, 61, 165, 0.9)';
const secondaryMain = '#53565A';
const secondaryMainOpacity = 'rgba(83, 86, 90, 0.5)';
const secondaryLight = '#53565A';
const tertiaryMain = '#53565A';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
